module.exports = __webpack_public_path__ + "static/media/topr-wallet-logo.77d2ed5c.jpg";